import { DateTime } from "luxon";
import { AdminGetRoutesLocationsResDto } from "service/api/estabrookSchemas";
import { MapMarker } from "../components/map/map.types";
import { RouteStatus } from "../pages/dashboard/route-planner/helpers/route-status.enum";

export const hasInProgressLocations = (addresses: MapMarker[]) => {
  return (
    addresses.some((address) => address.driverStatus === "inProgress") &&
    addresses.length > 1
  );
};

// When the driver started their first stop, i.e. when plowing actually began.
// The scheduled start time is a fixed slot, so it can be off by a few minutes.
export const getActualStartTime = (
  locations: AdminGetRoutesLocationsResDto[] = [],
  routeStatus?: string,
): string | undefined => {
  if (routeStatus !== RouteStatus.Live && routeStatus !== RouteStatus.Ended) {
    return undefined;
  }

  const serviceStartTimes = locations
    .map(({ driverServiceStartTime }) =>
      driverServiceStartTime ? DateTime.fromISO(driverServiceStartTime) : null,
    )
    .filter((time): time is DateTime => !!time?.isValid);

  if (serviceStartTimes.length === 0) return undefined;

  return DateTime.min(...serviceStartTimes)?.toISO() ?? undefined;
};
